import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import '../styles/Mobilya.css';
import { FaWhatsapp } from "react-icons/fa";

const Mobilya = () => {
  const navigate = useNavigate();

  const handleCategoryClick = (brand, category) => {
    // Türkçe karakterleri URL-friendly hale getir
    const categoryId = category
      .toLowerCase()
      .replace(/ğ/g, 'g')
      .replace(/ü/g, 'u')
      .replace(/ş/g, 's')
      .replace(/ı/g, 'i')
      .replace(/ö/g, 'o')
      .replace(/ç/g, 'c')
      .replace(/\s+/g, '-')
      .replace(/[^a-z0-9-]/g, '');
    
    navigate(`/${brand}#${categoryId}`);
  };

  return (
    <div className="mobilya">
      <Header />
      
      <main className="main-content">
        {/* Hero Section */}
        <section className="page-hero">
          <div className="hero-content">
            <h1>Mobilya Koleksiyonumuz</h1>
            <p>Evinizin her odası için özel tasarım mobilya çözümleri</p>
          </div>
        </section>

        {/* Categories Grid */}
        <section className="mobilya-categories">
          <div className="container">
            <h2>Mobilya Markalarımız</h2>
            <div className="categories-grid">
              <div className="category-card">
                <div className="category-header weltew-bg">
                  <div className="category-icon"><img width={100} src='../files/weltew-logo.png' alt='Weltew Mobilya'/></div>
                  <h3>Weltew Mobilya</h3>
                </div>
                <div className="category-content">
                  <p>Premium kalitede mobilya çözümleri ile evinizi güzelleştirin</p>
                  <div className="category-items">
                    <div className="category-item" onClick={() => handleCategoryClick('weltew-mobilya', 'Yatak Odası')}>
                      <span className="item-icon">🛏️</span>
                      <span>Yatak Odası</span>
                    </div>
                    <div className="category-item" onClick={() => handleCategoryClick('weltew-mobilya', 'Yemek Odası')}>
                      <span className="item-icon">🍽️</span>
                      <span>Yemek Odası</span>
                    </div>
                    <div className="category-item" onClick={() => handleCategoryClick('weltew-mobilya', 'Koltuk Takımı')}>
                      <span className="item-icon">🛋️</span>
                      <span>Koltuk Takımı</span>
                    </div>
                    <div className="category-item" onClick={() => handleCategoryClick('weltew-mobilya', 'Genç Odası')}>
                      <span className="item-icon">👦🏻</span>
                      <span>Genç Odası</span>
                    </div>
                  </div>
                  <div className="category-action">
                    <Link to="/weltew-mobilya" className="button">Detayları Gör →</Link>
                  </div>
                </div>
              </div>
              
              <div className="category-card">
                <div className="category-header bellona-bg">
                  <div className="category-icon"><img width={190} src='../files/bellona-logo.png' alt='Bellona Mobilya'/></div>
                  <h3>Bellona Mobilya</h3>
                </div>
                <div className="category-content">
                  <p>Modern tasarım ve üstün kalitede mobilya koleksiyonları</p>
                  <div className="category-items">
                    <div className="category-item" onClick={() => handleCategoryClick('bellona-mobilya', 'Yatak Odası')}>
                      <span className="item-icon">🛏️</span>
                      <span>Yatak Odası</span>
                    </div>
                    <div className="category-item" onClick={() => handleCategoryClick('bellona-mobilya', 'Yemek Odası')}>
                      <span className="item-icon">🍽️</span>
                      <span>Yemek Odası</span>
                    </div>
                    <div className="category-item" onClick={() => handleCategoryClick('bellona-mobilya', 'Koltuk Takımı')}>
                      <span className="item-icon">🛋️</span>
                      <span>Koltuk Takımı</span>
                    </div>
                    <div className="category-item" onClick={() => handleCategoryClick('bellona-mobilya', 'Genç Odası')}>
                      <span className="item-icon">👦🏻</span>
                      <span>Genç Odası</span>
                    </div>
                  </div>
                  <div className="category-action">
                    <Link to="/bellona-mobilya" className="button">Detayları Gör →</Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Features Section */}
        <section className="mobilya-features">
          <div className="container">
            <h2>Mobilya Kalitemizin Özellikleri</h2>
            <div className="features-grid">
              <div className="feature-item">
                <div className="feature-icon">🌳</div>
                <h3>Kaliteli Malzeme</h3>
                <p>En kaliteli ahşap ve malzemeler kullanılarak üretilir</p>
              </div>
              <div className="feature-item">
                <div className="feature-icon">🎨</div>
                <h3>Modern Tasarım</h3>
                <p>Güncel trendlere uygun modern tasarım anlayışı</p>
              </div>
              <div className="feature-item">
                <div className="feature-icon">🔧</div>
                <h3>Uzman İşçilik</h3>
                <p>Deneyimli ustalar tarafından özenle üretilir</p>
              </div>
              <div className="feature-item">
                <div className="feature-icon">🚚</div>
                <h3>Ücretsiz Teslimat</h3>
                <p>Belirli bölgelerde ücretsiz teslimat hizmeti</p>
              </div>
              <div className="feature-item">
                <div className="feature-icon">🛠️</div>
                <h3>Montaj Hizmeti</h3>
                <p>Profesyonel montaj ekibi ile kurulum</p>
              </div>
              <div className="feature-item">
                <div className="feature-icon">🛡️</div>
                <h3>Garanti</h3>
                <p>Tüm ürünlerimiz garanti kapsamındadır</p>
              </div>
            </div>
          </div>
        </section>

        {/* Contact Section */}
        <section className="contact-section">
          <div className="container">
            <div className="contact-content">
              <h2>Mobilya İhtiyaçlarınız İçin Bizimle İletişime Geçin</h2>
              <p>Size en uygun mobilya çözümlerini sunmak için buradayız.</p>
              <div className="contact-buttons">
                <a href="tel:+905496250335" className="btn btn-primary">📞 Hemen Ara</a>
                <a href="https://wa.me/905496250335" target="_blank" rel="noopener noreferrer" className="btn btn-secondary">
                  <FaWhatsapp style={{ marginRight: 8, fontSize: 20, verticalAlign: 'middle' }} />
                  WhatsApp
                </a>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default Mobilya; 